import { createAsyncThunk } from "@reduxjs/toolkit";
import ObservationsByAuthorityAPI, {
  GetPostIRAssessmentsResponse,
  SavePostIRAssessmentsRequest,
  SavePostIRAssessmentsResponse,
} from "../../../../../../src/api/observationByAuthority";
import { RootState } from "../../../../../app/store";

export const fetchAssessments = createAsyncThunk<
  GetPostIRAssessmentsResponse,
  string,
  { rejectValue: string }
>(
  "observationsByAuthority/fetchAssessments",
  async (case_id, { rejectWithValue }) => {
    try {
      return await ObservationsByAuthorityAPI.get(case_id);
    } catch (error) {
      return rejectWithValue("Failed to fetch assessments");
    }
  },
  {
    condition: (case_id, { getState }) => {
      const state = getState() as RootState;
      const { caseId, fetchStatus } = state.observationsByAuthority;
      if (caseId === case_id && fetchStatus === "succeeded") {
        return false;
      }
      return true;
    },
  },
);

export const saveAssessments = createAsyncThunk<
  SavePostIRAssessmentsResponse,
  { case_id: string; payload: SavePostIRAssessmentsRequest },
  { rejectValue: string }
>(
  "observationsByAuthority/saveAssessments",
  async ({ case_id, payload }, { rejectWithValue }) => {
    try {
      return await ObservationsByAuthorityAPI.post(case_id, payload);
    } catch (error) {
      return rejectWithValue("Failed to save assessments");
    }
  },
);
